export default __webpack_public_path__ + "static/media/ape-bnb.76948aeb.png";